// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DropzoneTextTable_wrapper__15A_u","form":"DropzoneTextTable_form__1zHgU","field":"DropzoneTextTable_field__2GtZv","user":"DropzoneTextTable_user__JL1mQ"};